/**
 * @desc 导出退款单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.AsRefundOrderRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/asRefundOrder/export`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
